// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".productClass{padding-top:32px;padding-left:8px}\n", "",{"version":3,"sources":["webpack://./../packages/ecwizard/src/components/Products/product.scss"],"names":[],"mappings":"AAAA,cACE,gBAAiB,CACjB,gBAAiB","sourcesContent":[".productClass {\n  padding-top: 32px;\n  padding-left: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
